/*=========================================================================================
  File Name: actions.js
  Namespace: sonar
  Description: Vuex Store - Sonar actions
==========================================================================================*/
import {
  getSonarAssessmentID,
  listSonar,
  editSonar,
  createSonar,
  getSonar
} from "@/services/sonar.service";
import { shortenUUIDs } from '@/utils/utils';

const actions = {
  async getSonarAction({ commit }, { sonarId }) {
    const response = await getSonar({ sonarId });
    if (response) {
      commit('STORE_CURRENT_SONAR_ASSESSMENT', response);
    }
    return response;
  },

  async getSonarAssessmentById({ commit }, sonarId) {
    const response = await getSonarAssessmentID({ sonarId });
    if (response) {
      commit('STORE_CURRENT_SONAR_ASSESSMENT', response);
    }
    return response;
  },

  resetCurrentSonar({ commit }) {
    commit('RESET_CURRENT_SONAR');
  },

  async saveSonarToApi({ getters }) {
    const currentSonar = getters.getCurrentSonar;
    const response = currentSonar.id
      ? await editSonar({ ...currentSonar, sonarId: currentSonar.SkillArea.id, operation: 'update' })
      : await createSonar({ ...currentSonar, operation: 'create' });
    return response;
  },

  async getAllSonarAssessments({ commit }, params = {}) {
    if (params.ids && params.ids.length > 20) {
      params.ids = shortenUUIDs(params.ids);
    }
    const response = await listSonar(params);
    if (response) {
      commit('STORE_LIST_SONAR', response);
    }
    return response;
  },
};

export default actions;
